module.exports = __webpack_public_path__ + "static/media/Rysunek14.6b8ab391.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/szatnia/Rysunek14.jpg
// module id = 260
// module chunks = 0